import { Injectable } from '@angular/core';
import { ConfidentialityDisabler } from './confidentiality-disabler';
import { ConfidentialityRecord, shouldDisableByConfidentialityLevels } from './confidentiality-disabler.const';

/**
 * Default service to check if record confidentiality level is greater than
 * user's confidentiality level from MIQ's attributes
 *
 * This is useful to disable or block users from change confidentiality level inputs
 */
@Injectable()
export class ConfidentialityDisablerService implements ConfidentialityDisabler<ConfidentialityRecord> {
  /**
   * Returns true if record confidentiality level is bigger than user confidentialities
   * from MIQ's properties
   * @param record: {ConfidentialityRecord}
   * @returns boolean
   * @example
   */
  shouldDisable(record: ConfidentialityRecord): boolean {
    return shouldDisableByConfidentialityLevels(record);
  }
}
